import { environment } from '../../../environments/environment';

function readRuntimeApiBaseOverride(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const w = window as unknown as { __WASEL_ADMIN_API_BASE__?: string };
  const v = w.__WASEL_ADMIN_API_BASE__?.trim();
  // A value starting with `__` means the entrypoint did not substitute the index.html placeholder.
  return v && !v.startsWith('__') ? v : undefined;
}

/** Wasel API origin (no trailing slash). Build-time `environment.apiBaseUrl` unless `window.__WASEL_ADMIN_API_BASE__` is set at deploy time. */
export const appEnv = {
  get apiBaseUrl(): string {
    return readRuntimeApiBaseOverride() ?? environment.apiBaseUrl;
  },
};

